module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-item', {
    attrs: {
      "data": _vm.isPost ? _vm.postInfo : _vm.data,
      "show-date": _vm.showDate,
      "is-incard": _vm.isPost ? _vm.isInCard : false
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-03d5b676"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/card/card.vue
// module id = 197
// module chunks = 1